import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from 'src/environments/environment';

import { SpacesEffects } from './spaces/spaces.effects';
import { GlobalEffects } from './global';
import { RemotePickupEffects } from './remote-pickup';
import { SettingsEffects } from './settings';
import { storageMetaReducer } from './storage.metareducer';
import { reducers } from './store';

const extModules = [];
if (!environment.production) {
  extModules.push(
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: true,
    })
  );
}

const EFFECTS = [GlobalEffects, SpacesEffects, SettingsEffects, RemotePickupEffects];

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers: [storageMetaReducer] }),
    EffectsModule.forRoot(EFFECTS),
    ...extModules,
  ],
  exports: [StoreModule, EffectsModule],
})
export class StoresModule {}
